
      import API from "!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import getTarget from "!../../../../node_modules/style-loader/dist/runtime/getTarget.js";
      import insertStyleElement from "!../../../../node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import content, * as namedExport from "!!../../../../node_modules/mini-css-extract-plugin/dist/loader.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[3]!../../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[4].use[4]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[5]!./IconLabel.scss";
      
      

var options = {};

options.styleTagTransform = function(css, style){
      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
      while (style.firstChild) {
        style.removeChild(style.firstChild);
      }

      style.appendChild(document.createTextNode(css));
    }
  };
options.setAttributes = function(style) {
        var nonce =
          typeof __webpack_nonce__ !== "undefined" ? __webpack_nonce__ : null;

        if (nonce) {
          style.setAttribute("nonce", nonce);
        }
      };
options.insert = function(style){
    var target = getTarget("head");

    if (!target) {
      throw new Error(
        "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
      );
    }

    target.appendChild(style);
  };
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../node_modules/mini-css-extract-plugin/dist/loader.js??ruleSet[1].rules[0].oneOf[4].use[1]!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[3]!../../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[4].use[4]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[4].use[5]!./IconLabel.scss";
       export default content && content.locals ? content.locals : undefined;
